<template>
    <div class="page">
        <div>
            <text-headline-primary class="center">
                {{ texts.title }}
            </text-headline-primary>

            <div class="center subtitle">
                {{ texts[downloadToken ? "email" : "snailmail"] }}
            </div>
        </div>

        <div v-if="downloadToken" class="center">
            <text-button autofocus @click="downloadButtonAction">
                {{ texts.download_ticket }}
            </text-button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import TextButton from "@/components/elements/TextButton";
import { FLOW_STEP_ORDER_CONFIRMED } from "@/store/modules/flow";

export default {
    components: {
        TextButton
    },
    computed: {
        texts() {
            return this.$t("page_order_confirmed");
        },
        ...mapGetters({
            downloadToken: "order/getDownloadToken"
        })
    },
    mounted() {
        // push the token into the url if not there, so we can refresh
        if (
            this.downloadToken &&
            this.$route.query.token !== this.downloadToken
        ) {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    token: this.downloadToken
                }
            });
        }

        // get the token from the url if we have refreshed
        if (
            this.$route.query.token &&
            this.downloadToken !== this.$route.query.token
        ) {
            this.$store.commit(
                "order/setDownloadToken",
                this.$route.query.token
            );
        }

        this.$store.commit("flow/setStep", FLOW_STEP_ORDER_CONFIRMED);
    },
    methods: {
        downloadButtonAction() {
            window.open(
                process.env.VUE_APP_API_URL +
                    "v1/tickets/download?downloadtoken=" +
                    this.downloadToken
            );
        }
    }
};
</script>

<style scoped>
.page {
    padding: 2rem 1rem;
}

.center {
    text-align: center;
    margin: auto;
    padding-top: 1em;
}
</style>
